<template>
  <!--Main Content-->
  <div class="main-content px-0 app-content">
    <!--Main Content Container-->
    <div class="container-fluid">
      <!--Page Header-->
      <Breadcrumb />
      <!--Page Header-->
      <!-- <div class="forms mb-5 card rounded">
        <MaintenanceForm :user="this.user" />
      </div> -->

      <div class="">
        <div class="row row-sm">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
            <div class="card">
              <div class="card-body pb-0 border-bottom">
                <div class="d-flex mb-3">
                  <h6 class="card-title mb-0">All Maintenance</h6>
                  <div class="card-option ml-auto d-none d-md-flex">
                    <div class="mr-2">
                      <!-- <router-link to="/createmaintenance"><button class="btn btn-primary btn-sm rounded-lg fs-13"><i class="mdi mdi-plus-circle-outline"></i>Create New Maintenance </button></router-link> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <form class="card m-3" @submit.prevent="getAllMaintenance()">
                  <div class="m-3 p-3 row">
                    <div class="col-md-6">
                      <!-- <h5 class="mb-3 bg-light p-2">Generate By Date</h5> -->
                      <p>Start Date</p>
                      <input
                        class="form-control"
                        type="date" required
                        v-model="startDate"
                        name="start"
                      />
                    </div>

                    <div class="col-md-6">
                      <!-- <h5 class="mb-3 bg-light p-2">
                      Generate By Category Or Status
                    </h5> -->

                      <p>End Date</p>
                      <input
                        v-model="endDate"
                        class="form-control"
                        type="date" required
                        name="end"
                      />
                    </div>
                    <button v-if="loading" class="btn btn-primary" disabled>
                      Loading
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span style="width: 2px" class="sr-only text-light"
                          >Loading...</span
                        >
                      </div>
                    </button>
                    <input
                      v-else-if="allMaintenance.length == 0"
                      class="ml-3 btn btn-primary"
                      type="submit"
                      value="Generate"
                    />
                    <button class="ml-5 btn btn-warning" @click.prevent="reset">
                      Reset
                    </button>
                  </div>
                </form>

                <div class="card m-3">
                  <div class="table-responsive">
                    <table
                      id="example"
                      class="table table-striped"
                      style="width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>Maintenance Id</th>
                          <th>Maintenance Name</th>
                          <th>Asset ID</th>
                          <th>Asset Name</th>
                          <th>Maintenance Status</th>
                          <th>Maintenance Type ID</th>
                          <th>Registration Number</th>

                          <th>Description Of Maintenance</th>
                          <th>Maintenance Cost</th>
                          <th>Staff Assigned To</th>
                          <th>Date</th>
                          <th>Maintenance Due Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="maintenance in allMaintenance"
                          :key="maintenance.id"
                        >
                          <td>{{ maintenance.id }}</td>
                          <td>{{ maintenance.name }}</td>
                          <td>{{ maintenance.assetId }}</td>
                          <td>{{ maintenance.assetName }}</td>
                          <td>{{ maintenance.status }}</td>
                          <td>{{ maintenance.maintenanceTypeId }}</td>
                          <td>{{ maintenance.registrationNumber }}</td>

                          <td>{{ maintenance.descriptionofMaintenance }}</td>
                          <td>{{ maintenance.maintenanceCost }}</td>
                          <td>{{ maintenance.staffAssignTo }}</td>
                          <td>{{ maintenance.date.split("T")[0] }}</td>
                          <td>
                            {{ maintenance.maintenanceDueDate.split("T")[0] }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- COL END -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
//import MaintenanceForm from "@/components/MaintenanceForm";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    //MaintenanceForm,
    Breadcrumb,
  },

  props: ["user", "BaseURL"],

  data() {
    return {
      loading: false,
      allMaintenance: [],

      startDate: "",
      endDate: "",
      categoryId: 0,
      status: "",
    };
  },

  beforeCreate() {
    if (localStorage.getItem("role") !== "User") {
      window.location = "/error";
    }
  },

  methods: {
    getAllMaintenance() {
      this.loading = true;
      fetch(
        this.BaseURL +
          "/getMaintenanceByDate/" +
          this.startDate +
          "/" +
          this.endDate,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          this.allMaintenance = data;

          if (this.allMaintenance.length == 0) {
            this.loading = false;
            alert(
              `No Data Available Within Specified Date Or Category To Show`
            );
          } else {
            this.loading = false;
            $(() => {
              $("#example").DataTable({
                dom: "Bfrtip",
                buttons: [
                  "colvis",
                  "copyHtml5",
                  "csvHtml5",
                  "excel",
                  "pdf",
                  "print",
                ],
              });
            });
          }
          //console.log(data);
          // this.isSuccessful = data.isSuccess;
          // this.errorMessage = data.message;
        });
    },

    reset() {
      window.location.reload(true);
    },
  },
};
</script>